// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__nTWi2","header":"PatientBlock_header__3zl-y","label":"PatientBlock_label__15EIG","option":"PatientBlock_option__236ka"};